import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import styled from "styled-components";

const BANNER_DEFAULT_COLOR = "#0c7266";
const BANNER_AMOUNT_FONT_SIZE = "56px";
const BANNER_AMOUNT_FONT_WEIGHT = 800;
const BANNER_AMOUNT_LETTER_SPACING = "-0.8px";
const BANNER_DIVIDER_WIDTH = "220px";
const TICK_DIMENSIONS = {
    height: 50,
    width: 50,
};

interface IColorProp {
    colorCode?: string;
}

export const SuccessBannerWrapper = styled.div({
    textAlign: "center",
});

export const TickContainer = styled.div(({ theme }) => ({
    height: TICK_DIMENSIONS.height,
    width: TICK_DIMENSIONS.width,
    marginTop: theme.spacing.medium,
    marginRight: "auto",
    marginBottom: theme.spacing.medium,
    marginLeft: "auto",
}));

export const TickImage = styled(Image)({
    height: "100%",
    objectFit: "cover",
    width: "100%",
});

export const BillClearedText = styled(Text)<IColorProp>(({ colorCode }) => ({
    color: colorCode || BANNER_DEFAULT_COLOR,
}));

export const TotalAmountText = styled(Text)<IColorProp>(({ colorCode, theme }) => ({
    fontSize: BANNER_AMOUNT_FONT_SIZE,
    color: colorCode || BANNER_DEFAULT_COLOR,
    marginTop: `calc(${theme.spacing.x3} * -1)`,
    fontStyle: "normal",
    fontWeight: BANNER_AMOUNT_FONT_WEIGHT,
    lineHeight: "normal",
    letterSpacing: BANNER_AMOUNT_LETTER_SPACING,
}));

export const DividingLine = styled.div(({ theme }) => ({
    borderTop: `1px solid ${theme.colors[theme.colorMode].background_Overlay_Light}`,
    margin: "0 auto",
    marginBottom: theme.spacing.medium,
    width: BANNER_DIVIDER_WIDTH,
}));

export const StyledText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
}));
